// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-size: 16px;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #f4eeee inset !important;
}

/* https://tailwindcss.com/docs/preflight */

/*
    A set of base styles that are designed to smooth over cross-browser inconsistencies

    1. Default margins are removed
    2. Headings are unstyled
    3. Lists are unstyled
    4. Images and other replaced elements (like svg, video, canvas, and others) are display: block by default.
    5. Border styles are reset globally
    6. Buttons have a default outline
    */

/*
    1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
    2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
    */

*,
::before,
::after {
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box; /* Opera/IE 8+ */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
    1. Use a consistent sensible line-height in all browsers.
    2. Prevent adjustments of font size after orientation changes in iOS.
    3. Use a more readable tab size.
    4. Use the user's configured \\\`sans\\\` font-family by default.
    */

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', 'Noto Color Emoji'; /* 4 */
}

/*
    1. Remove the margin in all browsers.
    2. Inherit line-height from \\\`html\\\` so users can set them as a class directly on the \\\`html\\\` element.
    */

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
    1. Add the correct height in Firefox.
    2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
    3. Ensure horizontal rules are visible by default.
    */

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
    Add the correct text decoration in Chrome, Edge, and Safari.
    */

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
    Remove the default font size and weight for headings.
    */

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
    Reset links to optimize for opt-in styling instead of opt-out.
    */

a {
  color: inherit;
  text-decoration: inherit;
}

/*
    Add the correct font weight in Edge and Safari.
    */

b,
strong {
  font-weight: bolder;
}

/*
    1. Use the user's configured \\\`mono\\\` font family by default.
    2. Correct the odd \\\`em\\\` font sizing in all browsers.
    */

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
    'Courier New', monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
    Add the correct font size in all browsers.
    */

small {
  font-size: 80%;
}

/*
    Prevent \\\`sub\\\` and \\\`sup\\\` elements from affecting the line height in all browsers.
    */

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
    1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
    2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
    3. Remove gaps between table borders by default.
    */

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
    1. Change the font styles in all browsers.
    2. Remove the margin in Firefox and Safari.
    3. Remove default padding in all browsers.
    */

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
    Remove the inheritance of text transform in Edge and Firefox.
    */

button,
select {
  text-transform: none;
}

/*
    1. Correct the inability to style clickable types in iOS and Safari.
    2. Remove default button styles.
    */

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  /* background-color: transparent; */ /* 2 */
  background-image: none; /* 2 */
}

/*
    Use the modern Firefox focus style for all focusable elements.
    */

:-moz-focusring {
  outline: auto;
}

/*
    Remove the additional \\\`:invalid\\\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
    */

:-moz-ui-invalid {
  box-shadow: none;
}

/*
    Add the correct vertical alignment in Chrome and Firefox.
    */

progress {
  vertical-align: baseline;
}

/*
    Correct the cursor style of increment and decrement buttons in Safari.
    */

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
    1. Correct the odd appearance in Chrome and Safari.
    2. Correct the outline style in Safari.
    */

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
    Remove the inner padding in Chrome and Safari on macOS.
    */

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
    1. Correct the inability to style clickable types in iOS and Safari.
    2. Change font properties to \\\`inherit\\\` in Safari.
    */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
    Add the correct display in Chrome and Safari.
    */

summary {
  display: list-item;
}

/*
    Removes the default spacing and border for appropriate elements.
    */

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
    Prevent resizing textareas horizontally by default.
    */

textarea {
  resize: vertical;
}

/*
    1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
    2. Set the default placeholder color to the user's configured gray 400 color.
    */

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
    Set the default cursor for buttons.
    */

button,
[role='button'] {
  cursor: pointer;
}

/*
    Make sure disabled buttons don't get the pointer cursor.
    */
:disabled {
  cursor: default;
}

/*
    1. Make replaced elements \\\`display: block\\\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
    2. Add \\\`vertical-align: middle\\\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
       This can trigger a poorly considered lint error in some tools but is included by design.
    */

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
    Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
    */

img,
video {
  height: auto;
}

video {
  max-width: 100%;
}

/*
    Ensure the default browser behavior of the \\\`hidden\\\` attribute.
    */

[hidden] {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/global.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;;;;EAIE,uDAAuD;AACzD;;AAEA,2CAA2C;;AAE3C;;;;;;;;;KASK;;AAEL;;;KAGK;;AAEL;;;EAGE,8BAA8B,EAAE,gCAAgC;EAChE,2BAA2B,EAAE,yBAAyB;EACtD,sBAAsB,EAAE,gBAAgB;EACxC,eAAe,EAAE,MAAM;EACvB,mBAAmB,EAAE,MAAM;EAC3B,qBAAqB,EAAE,MAAM;AAC/B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;KAKK;;AAEL;EACE,gBAAgB,EAAE,MAAM;EACxB,8BAA8B,EAAE,MAAM;EACtC,gBAAgB,EAAE,MAAM;EACxB,WAAW,EAAE,MAAM;EACnB;;yCAEuC,EAAE,MAAM;AACjD;;AAEA;;;KAGK;;AAEL;EACE,SAAS,EAAE,MAAM;EACjB,oBAAoB,EAAE,MAAM;AAC9B;;AAEA;;;;KAIK;;AAEL;EACE,SAAS,EAAE,MAAM;EACjB,cAAc,EAAE,MAAM;EACtB,qBAAqB,EAAE,MAAM;AAC/B;;AAEA;;KAEK;;AAEL;EACE,iCAAiC;AACnC;;AAEA;;KAEK;;AAEL;;;;;;EAME,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;KAEK;;AAEL;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;KAEK;;AAEL;;EAEE,mBAAmB;AACrB;;AAEA;;;KAGK;;AAEL;;;;EAIE;4BAC0B,EAAE,MAAM;EAClC,cAAc,EAAE,MAAM;AACxB;;AAEA;;KAEK;;AAEL;EACE,cAAc;AAChB;;AAEA;;KAEK;;AAEL;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;KAIK;;AAEL;EACE,cAAc,EAAE,MAAM;EACtB,qBAAqB,EAAE,MAAM;EAC7B,yBAAyB,EAAE,MAAM;AACnC;;AAEA;;;;KAIK;;AAEL;;;;;EAKE,oBAAoB,EAAE,MAAM;EAC5B,eAAe,EAAE,MAAM;EACvB,oBAAoB,EAAE,MAAM;EAC5B,cAAc,EAAE,MAAM;EACtB,SAAS,EAAE,MAAM;EACjB,UAAU,EAAE,MAAM;AACpB;;AAEA;;KAEK;;AAEL;;EAEE,oBAAoB;AACtB;;AAEA;;;KAGK;;AAEL;;;;EAIE,0BAA0B,EAAE,MAAM;EAClC,mCAAmC,EAAE,MAAM;EAC3C,sBAAsB,EAAE,MAAM;AAChC;;AAEA;;KAEK;;AAEL;EACE,aAAa;AACf;;AAEA;;KAEK;;AAEL;EACE,gBAAgB;AAClB;;AAEA;;KAEK;;AAEL;EACE,wBAAwB;AAC1B;;AAEA;;KAEK;;AAEL;;EAEE,YAAY;AACd;;AAEA;;;KAGK;;AAEL;EACE,6BAA6B,EAAE,MAAM;EACrC,oBAAoB,EAAE,MAAM;AAC9B;;AAEA;;KAEK;;AAEL;EACE,wBAAwB;AAC1B;;AAEA;;;KAGK;;AAEL;EACE,0BAA0B,EAAE,MAAM;EAClC,aAAa,EAAE,MAAM;AACvB;;AAEA;;KAEK;;AAEL;EACE,kBAAkB;AACpB;;AAEA;;KAEK;;AAEL;;;;;;;;;;;;;EAaE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;KAEK;;AAEL;EACE,gBAAgB;AAClB;;AAEA;;;KAGK;;AAEL;;EAEE,UAAU,EAAE,MAAM;EAClB,cAAc,EAAE,MAAM;AACxB;;AAEA;;KAEK;;AAEL;;EAEE,eAAe;AACjB;;AAEA;;KAEK;AACL;EACE,eAAe;AACjB;;AAEA;;;;KAIK;;AAEL;;;;;;;;EAQE,cAAc,EAAE,MAAM;EACtB,sBAAsB,EAAE,MAAM;AAChC;;AAEA;;KAEK;;AAEL;;EAEE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;;KAEK;;AAEL;EACE,aAAa;AACf","sourcesContent":["body {\n  margin: 0;\n  font-size: 16px;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px #f4eeee inset !important;\n}\n\n/* https://tailwindcss.com/docs/preflight */\n\n/*\n    A set of base styles that are designed to smooth over cross-browser inconsistencies\n\n    1. Default margins are removed\n    2. Headings are unstyled\n    3. Lists are unstyled\n    4. Images and other replaced elements (like svg, video, canvas, and others) are display: block by default.\n    5. Border styles are reset globally\n    6. Buttons have a default outline\n    */\n\n/*\n    1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n    2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n    */\n\n*,\n::before,\n::after {\n  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */\n  -moz-box-sizing: border-box; /* Firefox, other Gecko */\n  box-sizing: border-box; /* Opera/IE 8+ */\n  border-width: 0; /* 2 */\n  border-style: solid; /* 2 */\n  border-color: #e5e7eb; /* 2 */\n}\n\n::before,\n::after {\n  --tw-content: '';\n}\n\n/*\n    1. Use a consistent sensible line-height in all browsers.\n    2. Prevent adjustments of font size after orientation changes in iOS.\n    3. Use a more readable tab size.\n    4. Use the user's configured \\`sans\\` font-family by default.\n    */\n\nhtml {\n  line-height: 1.5; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  -moz-tab-size: 4; /* 3 */\n  tab-size: 4; /* 3 */\n  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,\n    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',\n    'Segoe UI Symbol', 'Noto Color Emoji'; /* 4 */\n}\n\n/*\n    1. Remove the margin in all browsers.\n    2. Inherit line-height from \\`html\\` so users can set them as a class directly on the \\`html\\` element.\n    */\n\nbody {\n  margin: 0; /* 1 */\n  line-height: inherit; /* 2 */\n}\n\n/*\n    1. Add the correct height in Firefox.\n    2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n    3. Ensure horizontal rules are visible by default.\n    */\n\nhr {\n  height: 0; /* 1 */\n  color: inherit; /* 2 */\n  border-top-width: 1px; /* 3 */\n}\n\n/*\n    Add the correct text decoration in Chrome, Edge, and Safari.\n    */\n\nabbr:where([title]) {\n  text-decoration: underline dotted;\n}\n\n/*\n    Remove the default font size and weight for headings.\n    */\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n/*\n    Reset links to optimize for opt-in styling instead of opt-out.\n    */\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n/*\n    Add the correct font weight in Edge and Safari.\n    */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/*\n    1. Use the user's configured \\`mono\\` font family by default.\n    2. Correct the odd \\`em\\` font sizing in all browsers.\n    */\n\ncode,\nkbd,\nsamp,\npre {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',\n    'Courier New', monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/*\n    Add the correct font size in all browsers.\n    */\n\nsmall {\n  font-size: 80%;\n}\n\n/*\n    Prevent \\`sub\\` and \\`sup\\` elements from affecting the line height in all browsers.\n    */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/*\n    1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n    2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n    3. Remove gaps between table borders by default.\n    */\n\ntable {\n  text-indent: 0; /* 1 */\n  border-color: inherit; /* 2 */\n  border-collapse: collapse; /* 3 */\n}\n\n/*\n    1. Change the font styles in all browsers.\n    2. Remove the margin in Firefox and Safari.\n    3. Remove default padding in all browsers.\n    */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: inherit; /* 1 */\n  color: inherit; /* 1 */\n  margin: 0; /* 2 */\n  padding: 0; /* 3 */\n}\n\n/*\n    Remove the inheritance of text transform in Edge and Firefox.\n    */\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/*\n    1. Correct the inability to style clickable types in iOS and Safari.\n    2. Remove default button styles.\n    */\n\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n  -webkit-appearance: button; /* 1 */\n  /* background-color: transparent; */ /* 2 */\n  background-image: none; /* 2 */\n}\n\n/*\n    Use the modern Firefox focus style for all focusable elements.\n    */\n\n:-moz-focusring {\n  outline: auto;\n}\n\n/*\n    Remove the additional \\`:invalid\\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n    */\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\n/*\n    Add the correct vertical alignment in Chrome and Firefox.\n    */\n\nprogress {\n  vertical-align: baseline;\n}\n\n/*\n    Correct the cursor style of increment and decrement buttons in Safari.\n    */\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/*\n    1. Correct the odd appearance in Chrome and Safari.\n    2. Correct the outline style in Safari.\n    */\n\n[type='search'] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/*\n    Remove the inner padding in Chrome and Safari on macOS.\n    */\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/*\n    1. Correct the inability to style clickable types in iOS and Safari.\n    2. Change font properties to \\`inherit\\` in Safari.\n    */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/*\n    Add the correct display in Chrome and Safari.\n    */\n\nsummary {\n  display: list-item;\n}\n\n/*\n    Removes the default spacing and border for appropriate elements.\n    */\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\nfieldset {\n  margin: 0;\n  padding: 0;\n}\n\nlegend {\n  padding: 0;\n}\n\nol,\nul,\nmenu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/*\n    Prevent resizing textareas horizontally by default.\n    */\n\ntextarea {\n  resize: vertical;\n}\n\n/*\n    1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n    2. Set the default placeholder color to the user's configured gray 400 color.\n    */\n\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1; /* 1 */\n  color: #9ca3af; /* 2 */\n}\n\n/*\n    Set the default cursor for buttons.\n    */\n\nbutton,\n[role='button'] {\n  cursor: pointer;\n}\n\n/*\n    Make sure disabled buttons don't get the pointer cursor.\n    */\n:disabled {\n  cursor: default;\n}\n\n/*\n    1. Make replaced elements \\`display: block\\` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n    2. Add \\`vertical-align: middle\\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n       This can trigger a poorly considered lint error in some tools but is included by design.\n    */\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block; /* 1 */\n  vertical-align: middle; /* 2 */\n}\n\n/*\n    Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n    */\n\nimg,\nvideo {\n  height: auto;\n}\n\nvideo {\n  max-width: 100%;\n}\n\n/*\n    Ensure the default browser behavior of the \\`hidden\\` attribute.\n    */\n\n[hidden] {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
